import type { ReactNode } from 'react';
import { Dl, Dt, Dd } from './DefinitionList.styled';

export interface DefinitionItem {
  label: ReactNode;
  value: ReactNode;
  /** Hide rows whose `value` is null/undefined/empty-string. Defaults to true. */
  hideIfEmpty?: boolean;
}

interface DefinitionListProps {
  items: DefinitionItem[];
  maxWidth?: string;
}

const isEmptyValue = (v: ReactNode): boolean =>
  v === null || v === undefined || v === '' || v === false;

export default function DefinitionList({ items, maxWidth }: DefinitionListProps) {
  const visible = items.filter((it) => (it.hideIfEmpty === false ? true : !isEmptyValue(it.value)));
  if (visible.length === 0) return null;

  return (
    <Dl $maxWidth={maxWidth}>
      {visible.map((it, i) => (
        <FragmentRow key={i} item={it} />
      ))}
    </Dl>
  );
}

function FragmentRow({ item }: { item: DefinitionItem }) {
  return (
    <>
      <Dt>{item.label}</Dt>
      <Dd>{item.value}</Dd>
    </>
  );
}
